export default "__VITE_PUBLIC_ASSET__8d86bfb1__"